import React from "react";
import ReadQrCodeTemplate from "../../templates/readQrCodeTemplate/ReadQrCodeTemplate";


export default function ReadQrCodePage() {
    return (
        <ReadQrCodeTemplate />
    );
}